import React from "react";
import Coin from "../components/Coin/Coin";

const coinPage = () => {
  console.log()
  return (
    <>
      <Coin />
    </>
  );
};

export default coinPage;
